module.exports = __webpack_public_path__ + "assets/dec93400975ef3e4e87341586982e24f.mp3";